import { useTheme } from "@mui/material";

export default function AnotherZigzagIcon() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  if (isDark) {
    return (
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="17" fill="#B3BEFF" fillOpacity="0.04" />
        <g clipPath="url(#clip0_3178_1971)">
          <path d="M11.1613 4.51886H3.46777V2.8916H11.1613V4.51886Z" fill="white" />
          <path d="M3.46769 11.3425H1.92737V5.65137H3.46769V11.3425Z" fill="#EB6087" />
          <path d="M13.4677 11.3425H11.9274V5.65137H13.4677V11.3425Z" fill="#EB6087" />
          <path
            d="M12.5697 0.277231L9.45041 3.57254C9.38112 3.64574 9.38112 3.76442 9.45041 3.83761L12.5697 7.13293C12.6389 7.20612 12.7513 7.20612 12.8206 7.13293L15.9398 3.83761C16.0091 3.76442 16.0091 3.64574 15.9398 3.57254L12.8206 0.277231C12.7513 0.204033 12.6389 0.204034 12.5697 0.277231Z"
            fill="#EB6087"
          />
          <path
            d="M5.20968 10.5332H0.177419C0.0794334 10.5332 0 10.6171 0 10.7206V16.0369C0 16.1404 0.0794334 16.2244 0.177419 16.2244H5.20968C5.30766 16.2244 5.3871 16.1404 5.3871 16.0369V10.7206C5.3871 10.6171 5.30766 10.5332 5.20968 10.5332Z"
            fill="#EB6087"
          />
          <path
            d="M2.69355 6.46948C4.18116 6.46948 5.3871 5.19547 5.3871 3.6239C5.3871 2.05233 4.18116 0.77832 2.69355 0.77832C1.20594 0.77832 0 2.05233 0 3.6239C0 5.19547 1.20594 6.46948 2.69355 6.46948Z"
            fill="white"
          />
          <path
            d="M12.7016 16.2244C14.1892 16.2244 15.3952 14.9504 15.3952 13.3788C15.3952 11.8072 14.1892 10.5332 12.7016 10.5332C11.214 10.5332 10.0081 11.8072 10.0081 13.3788C10.0081 14.9504 11.214 16.2244 12.7016 16.2244Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_3178_1971">
            <rect width="16" height="16" fill="white" transform="translate(0 0.224609)" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3178_2096)">
        <path d="M11.1613 4.51886H3.46771V2.8916H11.1613V4.51886Z" fill="#181A46" />
        <path d="M3.46775 11.3425H1.92743V5.65137H3.46775V11.3425Z" fill="#D51A4E" />
        <path d="M13.4678 11.3425H11.9274V5.65137H13.4678V11.3425Z" fill="#D51A4E" />
        <path
          d="M12.5697 0.277231L9.45041 3.57254C9.38112 3.64574 9.38112 3.76442 9.45041 3.83761L12.5697 7.13293C12.6389 7.20612 12.7513 7.20612 12.8206 7.13293L15.9398 3.83761C16.0091 3.76442 16.0091 3.64574 15.9398 3.57254L12.8206 0.277231C12.7513 0.204033 12.6389 0.204034 12.5697 0.277231Z"
          fill="#D51A4E"
        />
        <path
          d="M5.20968 10.5332H0.177419C0.0794334 10.5332 0 10.6171 0 10.7206V16.0369C0 16.1404 0.0794334 16.2244 0.177419 16.2244H5.20968C5.30766 16.2244 5.3871 16.1404 5.3871 16.0369V10.7206C5.3871 10.6171 5.30766 10.5332 5.20968 10.5332Z"
          fill="#D51A4E"
        />
        <path
          d="M2.69355 6.46948C4.18116 6.46948 5.3871 5.19547 5.3871 3.6239C5.3871 2.05233 4.18116 0.77832 2.69355 0.77832C1.20594 0.77832 0 2.05233 0 3.6239C0 5.19547 1.20594 6.46948 2.69355 6.46948Z"
          fill="#181A46"
        />
        <path
          d="M12.7016 16.2244C14.1892 16.2244 15.3952 14.9504 15.3952 13.3788C15.3952 11.8072 14.1892 10.5332 12.7016 10.5332C11.214 10.5332 10.0081 11.8072 10.0081 13.3788C10.0081 14.9504 11.214 16.2244 12.7016 16.2244Z"
          fill="#181A46"
        />
      </g>
      <defs>
        <clipPath id="clip0_3178_2096">
          <rect width="16" height="16" fill="white" transform="translate(0 0.224609)" />
        </clipPath>
      </defs>
    </svg>
  );
}
